import React, { useState } from 'react'
import '../estilos/Header.css'
import logoejemplo from '../img/uniclima.png'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons'

function Header () {
  const [active, setActive] = useState('nav__menu')
  const [icon, setIcon] = useState('nav__toggler')

  const navToggle = () => {
    if (active === 'nav__menu') {
      setActive('nav__menu nav__active')
    } else setActive('nav__menu')

    if (icon === 'nav__toggler') {
      setIcon('nav__toggler toggle')
    } else setIcon('nav__toggler')
  }

  return (
    <nav className="nav">
      <NavLink to="/Uniclima" className="nav__brand"><img src={logoejemplo} alt='UniClima' className='logouniclima' /></NavLink>
      <ul className={active}>
        <li className="nav__item">
          <NavLink to="/Uniclima"
          className="nav__link"
          activeClassName='active'>UniClima</NavLink>
        </li>
        <li className="nav__item">
          <NavLink to="/Nosotros"
          className="nav__link"
          activeClassName='active'>Nosotros</NavLink>
        </li>
        <li className="nav__item">
          <NavLink to="/Servicios"
          className="nav__link"
          activeClassName='active'>Servicios y Proyectos</NavLink>
        </li>
        <li className="nav__item">
          <NavLink to="/Productos"
          className="nav__link"
          activeClassName='active'>Productos</NavLink>
        </li>
        <li className="nav__item">
          <NavLink to="/Contacto"
          className="nav__link"
          activeClassName='active'>Contacto</NavLink>
        </li>
      </ul>
      <div onClick={navToggle} className={icon}>
        <FontAwesomeIcon icon={icon === 'nav__toggler toggle' ? faXmark : faBars} />
      </div>
    </nav>
  )
}

export default Header
